import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { EdmMedicalAppShiftWithoutVisitFragment } from "lib/graphql/megaSchema";
import { isMidwife, isNurse } from "lib/tools/auth";
import { StaffGenreFilter, visitTypeLabelMap } from "views/StaffSchedule/tools";

dayjs.extend(isSameOrBefore);

export const shiftDateFilter = (
  shift: EdmMedicalAppShiftWithoutVisitFragment,
) => {
  const today = dayjs().startOf("day");

  return (
    dayjs(shift.day).startOf("day").isSameOrBefore(today) &&
    shift.state === "PUBLISHED"
  );
};

export const transformShiftsDay = (
  shift: EdmMedicalAppShiftWithoutVisitFragment,
) => ({
  ...shift,
  day: dayjs(shift.day).startOf("day").toISOString(),
});

export const sortShifts = (
  aShift: EdmMedicalAppShiftWithoutVisitFragment,
  bShift: EdmMedicalAppShiftWithoutVisitFragment,
) => {
  const dayDiff = dayjs(bShift.day).diff(dayjs(aShift.day));

  if (dayDiff) {
    return dayDiff;
  }

  const fullNameA =
    `${aShift.staff.firstname ?? ""} ${aShift.staff.lastname ?? ""}`.trim();
  const fullNameB =
    `${bShift.staff.firstname ?? ""} ${bShift.staff.lastname ?? ""}`.trim();

  return fullNameA.localeCompare(fullNameB, "pl", { sensitivity: "base" });
};

export const filterShiftsBySearchValue = (
  shift: EdmMedicalAppShiftWithoutVisitFragment,
  searchValue: string,
) => {
  if (!searchValue) {
    return shift;
  }

  const fullName =
    `${shift.staff.firstname ?? ""} ${shift.staff.lastname ?? ""}`.trim();

  const mappedVisitTypes = shift.visitTypes.map(
    (visitType) => visitTypeLabelMap[visitType],
  );

  return (
    fullName.toLowerCase().includes(searchValue.toLowerCase()) ||
    mappedVisitTypes.some((visitType) =>
      visitType.toLowerCase().includes(searchValue.toLowerCase()),
    )
  );
};

export const filterShiftsByStaffGenre = (
  shifts: EdmMedicalAppShiftWithoutVisitFragment[],
  selectedStaffGenre: StaffGenreFilter,
) => {
  if (selectedStaffGenre === "ALL") {
    return shifts;
  }

  return shifts.filter(({ staff }) => {
    if (selectedStaffGenre === "NURSE") return isNurse(staff);
    if (selectedStaffGenre === "MIDWIFE") return isMidwife(staff);
    return staff.genre === selectedStaffGenre;
  });
};
